import {H1, H2, H3, BodyParagraph, BodySpan} from './Typography';
export {H1, H2, H3, BodyParagraph, BodySpan};
export default {H1, H2, H3, Body: {Span: BodySpan, P: BodyParagraph}};
